<template>
  <v-checkbox
    :disabled="field.readonly"
    :error-messages="errors"
    :hide-details="dense"
    :model-value="modelValue"
    :rules="rules"
    @update:model-value="$emit('update:modelValue', $event)"
  >
    <template #label>
      <FieldLabel :field="field" />
    </template>
  </v-checkbox>
</template>

<script setup lang="ts">
defineProps<{
  field: FieldConfig
  rules?: FormRule[]
  errors?: string[]
  dense?: boolean
  modelValue: boolean | undefined
}>();
defineEmits(['update:modelValue']);
</script>
